export const NoStatements = () => {
  return <li className="py-4 px-4 text-[color:var(--gray12)]">No Statement found.</li>;
};
